import React, {useEffect, useState} from 'react';
import {Tooltip} from '../tooltip/tooltip';

interface VisualPart {
  percentage: string;
  color: string;
  title?: string;
}

interface ProgressLineProps {
  label?: string;
  backgroundColor?: string;
  visualParts?: VisualPart[];
  indeterminate?: boolean;
}

const ProgressLine: React.FC<ProgressLineProps> = ({
  label,
  backgroundColor = '#e5e5e5',
  visualParts = [{percentage: '0%', color: 'white'}],
  indeterminate = false,
}) => {
  const [widths, setWidths] = useState<string[]>(visualParts.map(() => '0%'));

  useEffect(() => {
    requestAnimationFrame(() => {
      setWidths(visualParts.map((item) => item.percentage));
    });
  }, [visualParts]);

  return (
    <>
      {label && <div className="progressLabel">{label}</div>}
      <div className="progressVisualFull" style={{backgroundColor}}>
        {indeterminate ? (
          <div className="progressVisualPart progressIndeterminatePart" />
        ) : (
          visualParts.map((item, index) => (
            <Tooltip title={item.title} key={index}>
              <div
                style={{width: widths[index], backgroundColor: item.color}}
                className="progressVisualPart"
              />
            </Tooltip>
          ))
        )}
      </div>
    </>
  );
};

export default ProgressLine;
